import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../store"
import OldUIContext from "../../olduicontext"

import PrintDialogue from "./components/PrintDialogue"
import {
    showDialogue,
    setItemId,
    setPrintOptions,
    showPrintView,
} from "./slice"
import { IPopupOptions } from "./index"
import { IOldUIContext } from "../../global"

interface OldUIInit {
    start: (element: HTMLElement | undefined | null) => void
    show: (itemId: number, options: IPopupOptions) => void
}

const init = (store: AppStore, oldUIContext: IOldUIContext): OldUIInit => {
    return {
        start: (element: HTMLElement | undefined | null): void => {
            if (!element) {
                throw new Error("Element should have value")
            }

            const root = createRoot(element)
            root.render(
                <Provider store={store}>
                    <OldUIContext.Provider value={oldUIContext}>
                        <PrintDialogue />
                    </OldUIContext.Provider>
                </Provider>,
            )
        },

        show: (itemId: number, options: IPopupOptions): void => {
            const { canShowAttachments, canShowComments, canShowHistory } =
                options
            const printOptions = {
                shouldPrintAttachments: false,
                shouldPrintComments: false,
                shouldPrintHistory: false,
            }
            store.dispatch(setItemId(itemId))
            store.dispatch(setPrintOptions(printOptions))
            if (canShowAttachments || canShowComments || canShowHistory) {
                store.dispatch(showDialogue(options))
            } else {
                showPrintView(itemId, printOptions)
            }
        },
    }
}

export default init
